import isEqual from 'lodash/isEqual';
import { useRouter } from 'next/router';
import { useContext, useEffect, useRef } from 'react';
import { trackReferralSourceClick } from '@/api/referral-source-click-trackings/track-referral-source-click';
import { SettingsContext } from '@/providers/SettingsProvider';
import { TopBarContent } from './TopBarContent';
import { TopBarHeader } from './TopBarHeader';
import { handleReferralTracking } from './handleReferralTracking';
import { setupSite } from './setupSite';
export const TopBar = () => {
  const router = useRouter();
  const settingsContext = useContext(SettingsContext);
  const previousRouterQueryRef = useRef(router.query);
  useEffect(() => {
    if (Object.keys(router.query).length === 0 || isEqual(previousRouterQueryRef.current, router.query)) {
      previousRouterQueryRef.current = router.query;
      return;
    }
    previousRouterQueryRef.current = router.query;
    handleReferralTracking(router.query, trackReferralSourceClick);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query]);
  useEffect(() => {
    setupSite(settingsContext?.settings);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <>
      <TopBarHeader data-sentry-element="TopBarHeader" data-sentry-source-file="index.tsx">
        <TopBarContent data-sentry-element="TopBarContent" data-sentry-source-file="index.tsx" />
      </TopBarHeader>
    </>;
};
export default TopBar;